export default "__VITE_ASSET__B2YjibrT__"